export const EmptyTemplate = (_: unknown) => null
